import { type FC } from 'react';

import { useListingByPinContext } from '@/microfrontends/listing/shared/context/ListingByPinContext';
import { useInitListingByPinCardApi } from '@/microfrontends/listing/shared/hooks/useInitCardApi';

import { CardsWithAdsContainer } from './CardsWithAdsContainer';

export const ListingByPinCardsContainer: FC = () => {
  const {
    adfox,
    listingProperties: { dealType },
    offers,
  } = useListingByPinContext();

  const initCardApi = useInitListingByPinCardApi();

  return <CardsWithAdsContainer adfox={adfox} dealType={dealType} initCardApi={initCardApi} offers={offers} />;
};
